import { text } from '@storybook/addon-knobs';
import { animate } from '../step/animations';
import { pad } from 'lodash';

const styleSheet = () => ({
  panoAnimHolder: {
    animation: 'SlideInFromLeft 0.6s ease-out forwards',
    animationDelay: '0',
    animationDuration: '0.3s',
    background: 'black',
  },
  container: {
    height: '100vh',
    maxWidth: '855px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '0 auto',
    '@media (max-width: 900px)': {
      width: '85%',
      justifyContent: 'unset',
      gap: '28px',
      marginTop: '50px',
    },
  },
  appilyContainer: {
    borderTop: '1px solid #B7C1E1',
    maxWidth: '855px',
    margin: '0 30px',
    '@media (max-width: 900px)': {
      maxWidth: '100%',
      margin: 0,
    },
  },
  flexContainer: {
    display: 'flex',
    textAlign: 'left',
    marginTop: '45px',
    justifyContent: 'space-between',
    '@media (max-width: 900px)': {
      flexDirection: 'column',
      marginTop: '26px',
    },
  },
  textContainer: {
    fontFamily: 'CircularStd, sans-serif',
    maxWidth: '493px',
    color: '#031D32',
  },
  headingContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    '@media (max-width: 900px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginBottom: '16px',
    },
  },
  stars: {
    animation: 'fadeInOut 1.3s ease-in-out infinite',
    opacity: 0.8,
    transform: 'scale(0.85)',
    '@media (max-width: 1024px)': {
      display: 'none',
    },
  },
  header: {
    color: '#031D32',
    display: 'inline-block',
    fontFamily: 'MuseoSansBold, CircularStd',
    '@media (max-width: 900px)': {
      padding: 0,
      margin: 0,
    },
  },
  subHeader: {
    color: '#031D32',
    fontFamily: 'MuseoSansStd, CircularStd',
    marginLeft: '35px',
    marginTop: '-12px',
    letterSpacing: '0.3px',
    '@media (max-width: 900px)': {
      margin: 0,
    },
  },
  arrow: {
    transform: 'scale(0.6)',
    marginTop: '1px',
  },
  overlay: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    zIndex: 5000,
    background: '#534e4e3b',
  },
  overlayContent: {
    boxShadow: '0 -24px 32px -16px rgba(0,0,0,0.18)',
    position: 'absolute',
    bottom: 0,
    height: '220px',
    width: '100%',
    padding: '50px 0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: 'black;',
    color: '#fff',
    fontFamily: 'CircularStd, sans-serif',
    letterSpacing: '0.5px',
    '@media (max-width: 900px)': {
      height: '300px',
    },
  },
  overlayText: {
    width: '30%',
    textAlign: 'center',
    lineHeight: '26px',
    fontSize: '16px',
    '@media (max-width: 900px)': {
      width: '70%',
      fontSize: '18px',
    },
  },
  overlayContinue: {
    color: '#fff',
    '@media (max-width: 900px)': {
      fontSize: '18px',
    },
  },
  closeButton: {
    position: 'absolute',
    right: '50px',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    filter: 'invert(100%) brightness(500%)',
    transform: 'scale(1.3)',
    '@media (max-width: 900px)': {
      right: '20px',
    },
  },
  appilyLogo: {
    width: '80px',
    position: 'absolute',
    bottom: '40px',
    '@media (max-width: 1024px)': {
      position: 'relative',
      bottom: 'unset',
    },
  },
  appilyLogoOverlay: {
    width: '80px',
  },
  subtitleText: {
    fontSize: '24px',
    fontFamily: 'MuseoSansBold, sans-serif',
    fontWeight: 'bold',
  },
  rightContainer: {
    background: 'white',
    opacity: 0,
    animation: 'SlideInFromRight 0.6s ease-out forwards',
    animationDelay: '0.4s',
    animationDuration: '0.3s',
    height: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
    boxSizing: 'border-box',
    fontFamily: 'CircularStd, sans-serif',
    fontSize: '18px',
    '@media (max-width: 1024px)': {
      height: 'auto',
      textAlign: 'center',
    },
  },
  paragraphText: {
    color: '#6C7882',
    fontSize: '16px',
    lineHeight: '28px',
    fontFamily: 'MuseoSansLight, sans-serif',
  },
  paraList: {
    fontFamily: 'MuseoSansLight, sans-serif',
    listStyle: 'none',
    padding: 0,
    '& li': {
      display: 'flex',
    },
    '& li:not(:last-child)': {
      marginBottom: '12px',
    },
    '@media (max-width: 1024px)': {
      display: 'none',
    },
  },
  appilyButton: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    color: '#ffffff',
    cursor: 'pointer',
    alignItems: 'center',
    alignSelf: 'center',
    gap: '2px',
    opacity: 0,
    border: 'none',
    backgroundColor: '#000000',
    borderRadius: '10px',
    height: '48px',
    padding: '0 24px',
    fontFamily: 'MuseoSansBold, sans-serif',
    fontSize: '16px',
    letterSpacing: '0.8px',
    marginTop: '30px',
    animation: 'ScaleIn 0.6s ease-out forwards',
    animationDelay: '0.7s',
    animationFillMode: 'forwards',
    transition: 'background 0.3s',
    '&:hover': {
      background: '#e48a19',
    },
  },
  appilyLogoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '50px',
  },
  panoHolder: {
    height: '100%',
    width: '65%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    zIndex: 1,
    '@media (max-width: 1024px)': {
      width: '100%',
      height: '290px',
    },
  },
  appilyPageCongainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    // background: 'black',
    '@media (max-width: 1024px)': {
      flexDirection: 'column',
    },
  },
  appilyStack: {
    display: 'flex',
    '@media (max-width: 1024px)': {
      flexDirection: 'column',
    },
  },
  sparkleHolder: {
    paddingLeft: '10px',
  },
  rightSizeController: {
    maxWidth: '400px',
    '@media (max-width: 900px)': {
      maxWidth: 'none',
    },
  },
  appilyIframeContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 6000,
    background: 'rgb(245, 245, 249)'
  },
  closeIframeButton: {
    top: '20px',
    right: '20px',
    position: 'absolute',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
  '@keyframes SlideInFromLeft': {
    from: {
      opacity: 0,
      transform: 'translateX(-10px)',
    },
    to: {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
  '@keyframes SlideInFromRight': {
    from: {
      opacity: 0,
      transform: 'translateX(30px)',
    },
    to: {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
  '@keyframes ScaleIn': {
    from: {
      opacity: 0,
      transform: 'scale(1.2)',
    },
    to: {
      opacity: 1,
      transform: 'scale(1)',
    },
  },
  '@keyframes ButtonShadowPulse': {
    '0%': {
      boxShadow: 'none',
    },
    '50%': {
      boxShadow: '0 0 16px 2px #F8971D, 0 0 32px 4px #F8971D66',
    },
    '100%': {
      boxShadow: 'none',
    },
  },
  '@keyframes fadeInOut': {
    '0%': { opacity: 0.5 },
    '50%': { opacity: 1 },
    '100%': { opacity: 0.5 },
  },
});

export default styleSheet;
